import { FC } from 'react'
import { Tag } from '../general/Tag.tsx'
import { Poi, Tag as TagType } from '@/js/types'
import { AddTag } from '@/js/editor/components/general/add/AddTag.tsx'
import { useTags } from '@/js/editor/hooks/api/useTags.ts'
import { useAtomValue, useSetAtom } from 'jotai'
import { updatePoiDraftAtom } from '@/js/editor/state/poiAtoms.ts'
import { poisAtom } from '@/js/editor/state/mapAtoms.ts'

type TagProps = {
    poi: Poi
}

export const PoiTags: FC<TagProps> = ({ poi }) => {
    const updateDraft = useSetAtom(updatePoiDraftAtom)
    const allPois = useAtomValue(poisAtom)
    const { destroy } = useTags()

    const removeTag = (tag: TagType) => {
        updateDraft({
            tags: poi.tags.filter((currentTag) => String(currentTag.id) !== String(tag.id)),
        })

        const poisWithTag = allPois.filter((currentPoi) =>
            currentPoi.tags.some((currentTag) => String(currentTag.id) === String(tag.id))
        )

        if (poisWithTag.length <= 1) {
            void destroy(tag).catch((error) => {
                console.error(error)
            })
        }
    }

    return (
        <div className={'flex-col pb-10'}>
            <div className={'flex flex-row justify-between items-center py-3  relative'}>
                <p className={'text-lg font-bold'}>Kategorien</p>

                <AddTag poi={poi} />
            </div>
            <div className={'flex flex-wrap flex-row align-middle space-x-2 space-y-3 overflow-y-auto'}>
                {poi.tags?.map((tag) => (
                    <Tag title={tag.name} key={tag.id} icon={'minus'} action={() => removeTag(tag)} />
                ))}
            </div>
        </div>
    )
}
